module.exports = __webpack_public_path__ + "static/media/innovacion.8b9a7feb.svg";